import { render, staticRenderFns } from "./bizCardModfiyPage.vue?vue&type=template&id=a23b7c30&scoped=true&"
import script from "./bizCardModfiyPage.vue?vue&type=script&lang=js&"
export * from "./bizCardModfiyPage.vue?vue&type=script&lang=js&"
import style0 from "./bizCardModfiyPage.vue?vue&type=style&index=0&id=a23b7c30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23b7c30",
  null
  
)

export default component.exports